module.exports = __webpack_public_path__ + "static/media/dog.02a7178e.svg";